import { ListCheck, type LucideIcon } from 'lucide-react';

export const SelectIcon: LucideIcon = ListCheck;
